import { KeyboardEvent } from 'react';

export const submitFormOnEnter = (event: KeyboardEvent<HTMLTextAreaElement>): void => {
  if (event.key !== 'Enter' || event.shiftKey || event.nativeEvent.isComposing) return;

  event.preventDefault();
  event.currentTarget.form?.requestSubmit();
};
